import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

// withCredentials: 認証 Cookie (HttpOnly) をリクエストに含める
const client = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
  withCredentials: true,
});

// 401 時に Cookie の refresh_token で再取得を試みる
let isRefreshing = false;
let failedQueue = [];

function processQueue(error) {
  failedQueue.forEach(p => error ? p.reject(error) : p.resolve());
  failedQueue = [];
}

// 401 を返しても refresh を試みない（=「未ログイン状態でアクセスする」種類の）エンドポイント。
// これらの初回認証フローで refresh が動くと、refresh_token Cookie が無い状態で
// 「リフレッシュトークンがありません」エラーが表示され、本来のエラー（パスワード違い等）が隠れる。
const NO_REFRESH_ON_401 = [
  '/auth/login',
  '/auth/register',
  '/auth/refresh',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/verify-email',
  '/auth/resend-verification',
  '/auth/2fa/verify',
  '/auth/accept-invite',
];

function shouldSkipRefresh(url) {
  if (!url) return false;
  return NO_REFRESH_ON_401.some(ep => url === ep || url.endsWith(ep));
}

client.interceptors.response.use(
  res => res,
  async err => {
    const original = err.config;
    if (err.response?.status !== 401 || original._retry || shouldSkipRefresh(original.url)) {
      return Promise.reject(err);
    }

    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject });
      }).then(() => client(original));
    }

    original._retry = true;
    isRefreshing = true;

    try {
      // refresh_token は Cookie で送られるので body 不要
      await axios.post('/auth/refresh', {}, {
        baseURL: API_BASE,
        withCredentials: true,
      });
      processQueue(null);
      return client(original);
    } catch (refreshErr) {
      processQueue(refreshErr);
      window.dispatchEvent(new Event('auth:logout'));
      return Promise.reject(refreshErr);
    } finally {
      isRefreshing = false;
    }
  },
);

export default client;
